import { DialogModal, ButtonArrange, Button } from '@cellula/react';
import { useState } from 'react';
import { withTranslation } from '@application/i18n/with_translation';
import { tokens } from '@cellula/react-theme-patient';
import { PrimitiveVonageEncryptionWarning } from './vonage_encryption_warning.component';
import { useVonageEncryptionWarning } from './use_vonage_excryption_warning.hook';

export function VonageEncryptionWarningDialog() {
	const { hasEncryptionSupport, appConfig } = useVonageEncryptionWarning();
	const [dialogOpen, setDialogOpen] = useState(true);

	if (hasEncryptionSupport) {
		return null;
	}

	function handleDialogOpenChange(open: boolean) {
		setDialogOpen(open);
	}

	return (
		<DialogModal.Root open={dialogOpen} onOpenChange={handleDialogOpenChange}>
			<DialogModal.Content>
				<DialogModal.Title>
					<PrimitiveVonageEncryptionWarning.Title />
				</DialogModal.Title>
				<DialogModal.Description>
					<PrimitiveVonageEncryptionWarning.Text type='dialog' />
				</DialogModal.Description>
			</DialogModal.Content>
			<DialogModal.Footer>
				<ButtonArrange gap={tokens.spacing.x1}>
					{appConfig?.appDownloadUrl ? (
						<Button as='a' variant='primary' href={appConfig.appDownloadUrl}>
							{withTranslation('VonageEncryptionWarning.Dialog.ButtonDownloadApp')}
						</Button>
					) : null}
					<DialogModal.Close asChild>
						<Button variant='ghost'>{withTranslation('Common.Button.Close')}</Button>
					</DialogModal.Close>
				</ButtonArrange>
			</DialogModal.Footer>
		</DialogModal.Root>
	);
}
